import SmallChat from '@sats-group/icons/18/chat';
import Chat from '@sats-group/icons/36/chat';
import Button from '@sats-group/ui-lib/react/button/button';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import type { StartChatCard as Props } from './start-chat-card.types';

const StartChatCard: React.FunctionComponent<Props> = ({
  title,
  description,
  ctaText,
}) => (
  <div className="start-chat-card">
    <div className="start-chat-card__content">
      <Chat />
      <div className="start-chat-card__text">
        <Text
          size={Text.sizes.headline2}
          theme={Text.themes.emphasis}
          elementName="h2"
        >
          {title}
        </Text>
        <div className="start-chat-card__description">
          <Text elementName="p">{description}</Text>
        </div>
      </div>
      <Button
        id="start-chat-card-trigger"
        text={ctaText}
        trailingIcon={<SmallChat />}
        variant={Button.variants.primaryWhite}
        wide
      />
    </div>
  </div>
);

export default StartChatCard;
